<template>
    <div
        class="relative flex items-center w-full px-4 py-6 mb-4 bg-white border border-gray-200 shadow-sm rounded-"
    >
        <div
            @click="show = !show"
            class="absolute top-0 right-0 flex items-center justify-center w-8 h-8 text-gray-500 border-b border-l border-gray-100 cursor-pointer hover:text-gray-900"
        >
            <svg
                v-show="show"
                class="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M19 9l-7 7-7-7"
                ></path>
            </svg>
            <svg
                v-show="!show"
                class="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M5 15l7-7 7 7"
                ></path>
            </svg>
        </div>
        <div class="w-full px-4 mx-auto sm:px-6 lg:px-8">
            <div class="max-w-4xl mx-auto">
                <div class="flex justify-between" v-show="show">
                    <h2
                        ref="scrollToMe"
                        @click="show = !show"
                        class="text-xl font-extrabold leading-9 text-left text-blue-600 cursor-pointer sm:text-xl sm:leading-10"
                    >
                        {{ achatsPrevisionnel.name }}
                    </h2>
                    <div @click="removeAchat">
                        <base-icon
                            width="60"
                            height="60"
                            class="h-8 cursor-pointer"
                            icon-name="trash"
                            viewBox="0 0 20 20 "
                            iconColor="#6C98C6"
                        >
                            <icon-trash />
                        </base-icon>
                    </div>
                </div>
                <div v-show="!show">
                    <div>
                        <div class="mt-4 ml-3 text-left">
                            <label
                                class="block my-2 mb-2 text-sm font-normal leading-5 tracking-wide text-gray-600 sm:font-normal sm:text-base sm:leading-10"
                                >Type de l’article :</label
                            >
                            <radio-box
                                label="Produit"
                                name="article"
                                :value="achatsPrevisionnel.choixArticle"
                                @change="
                                    payload =>
                                        (achatsPrevisionnel.choixArticle = payload)
                                "
                            />
                            <radio-box
                                class="ml-6"
                                name="article"
                                label="Service"
                                :value="achatsPrevisionnel.choixArticle"
                                @change="
                                    payload =>
                                        (achatsPrevisionnel.choixArticle = payload)
                                "
                            />
                        </div>
                        <base-input
                            placeholder="Désignation"
                            v-model="achatsPrevisionnel.name"
                            :hasError="$v.achatsPrevisionnel.name.$error"
                            :errorMessage="
                                errorMessage(
                                    'Désignation',
                                    $v.achatsPrevisionnel.name
                                )
                            "
                            @blur="$v.achatsPrevisionnel.name.$touch()"
                        />
                        <base-number-input
                            label="Prix d’achat unitaire (HT)"
                            v-model="achatsPrevisionnel.prixAchat"
                            :hasError="$v.achatsPrevisionnel.prixAchat.$error"
                            :errorMessage="
                                errorMessage(
                                    'Prix d’achat',
                                    $v.achatsPrevisionnel.prixAchat
                                )
                            "
                            @blur="$v.achatsPrevisionnel.prixAchat.$touch()"
                            :isCurrency="true"
                        />
                        <base-number-input
                            label="Quantité achetée"
                            v-model="achatsPrevisionnel.quantite"
                            :hasError="$v.achatsPrevisionnel.quantite.$error"
                            :errorMessage="
                                errorMessage(
                                    'Quantité achetée',
                                    $v.achatsPrevisionnel.quantite
                                )
                            "
                            @blur="$v.achatsPrevisionnel.quantite.$touch()"
                        />
                        <label
                            class="block my-2 mt-4 mb-2 text-sm font-normal leading-5 tracking-wide text-gray-600 sm:font-normal sm:text-base sm:leading-10"
                            ><span class="ml-2.5">Unité</span></label
                        >
                        <select-menu
                            width="w-40"
                            :option="units"
                            label="unite"
                            v-model="achatsPrevisionnel.unite"
                        />
                        <div class="mt-3 text-left">
                            <label
                                class="block my-2 mb-2 text-sm font-normal leading-5 tracking-wide text-gray-600 sm:font-normal sm:text-base sm:leading-10"
                                >Fréquence :</label
                            >
                            <div class="flex w-4/5">
                                <base-tag
                                    title="Mois"
                                    v-model="achatsPrevisionnel.date"
                                />
                                <base-tag
                                    title="Année"
                                    v-model="achatsPrevisionnel.date"
                                />
                            </div>
                        </div>

                        <div class="flex items-center mt-8">
                            <h5 class="mr-4">Import</h5>
                            <toggle
                                class="mr-6"
                                :triggered="achatsPrevisionnel.isImporter"
                                v-on:toggleTriggered="
                                    e => {
                                        achatsPrevisionnel.isImporter = e;
                                    }
                                "
                            />
                        </div>
                        <base-number-input
                            :max="100"
                            v-if="achatsPrevisionnel.isImporter"
                            label="Pourcentage de la part importée"
                            v-model="achatsPrevisionnel.pourcentagePartImportee"
                            :hasError="
                                $v.achatsPrevisionnel.pourcentagePartImportee
                                    .$error
                            "
                            :errorMessage="
                                errorMessage(
                                    'Pourcentage de la part importée',
                                    $v.achatsPrevisionnel
                                        .pourcentagePartImportee
                                )
                            "
                            @blur="
                                $v.achatsPrevisionnel.pourcentagePartImportee.$touch()
                            "
                        />
                    </div>

                    <div class="flex justify-end mt-4 ">
                        <base-secondary-button
                            color="red"
                            title="Supprimer"
                            @click="removeAchat"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import RadioBox from "@/components/forms/Toggles/radioBox";
import IconTrash from "@/components/icons/trash";
import SelectMenu from "@/components/forms/select/selectMenu";
import Toggle from "@/components/forms/Toggles/simpleToggle";
import { mapState } from "vuex";
import {
    required,
    integer,
    decimal,
    minValue,
    maxValue,
    minLength,
    maxLength
} from "vuelidate/lib/validators";
import { errorMessage } from "@/mixins/errorMessage.js";
import { scrollToRef } from "@/mixins/scrollToMixin.js";

export default {
    components: { IconTrash, RadioBox, SelectMenu, Toggle },
    props: {
        title: {
            type: String
        },
        object: {
            type: Object,
            required: true
        }
    },

    mixins: [errorMessage, scrollToRef],

    validations: {
        achatsPrevisionnel: {
            prixAchat: { required, decimal, minValue: minValue(0) },
            name: { minLength: minLength(3), maxLength: maxLength(75) },
            quantite: { integer, minValue: minValue(0) },
            pourcentagePartImportee: {
                decimal,
                minValue: minValue(0),
                maxValue: maxValue(100)
            }
        }
    },
    data() {
        return {
            achatsPrevisionnel: this.object,
            show: false
        };
    },
    methods: {
        addAchatsPrevisionnel() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                this.$store.dispatch(
                    "EtudeFinanciere/addAchatsPrevisionnel",
                    this.achatsPrevisionnel
                );
                this.show = true;
                return true;
            } else {
                this.show = false;
                return false;
            }
        },
        removeAchat() {
            this.$emit("remove", this.achatsPrevisionnel.id);
        }
    },
    computed: {
        ...mapState("forms", {
            units: state => state.units
        })
    }
};
</script>

<style></style>
